import { type OpenFeedback } from '../../modules/open-feedbacks/composables/useOpenFeedbacks'
import useGet from './api/useGet'
import { onMounted } from 'vue'

export const useGetFeedbackRequest = (input: { surveyId: string; feedbackReceiverId: string }) => {
  const {
    data: feedbackRequest,
    status: getFeedbackRequestStatus,
    load: loadFeedbackRequest,
  } = useGet<OpenFeedback>(`feedback/request/${input.surveyId}/${input.feedbackReceiverId}`)

  onMounted(() => {
    loadFeedbackRequest()
  })

  return {
    feedbackRequest,
    getFeedbackRequestStatus,
    loadFeedbackRequest,
  }
}
